import React, { useState } from 'react';
import styled from '@emotion/styled';
import { isValidFunc } from '@nykaa/utils/validations';

import AllVariants from 'shared/components/AllVariants';
import PartialHeader from 'shared/components/PartialHeader';
import Bag from 'shared/components/Header/RightNav/Bag';
import { useSelector } from 'react-redux';
import { State } from 'store/types';
import { isDeviceNotWeb } from 'helpers/utils/device';
import Actions from '../Actions';
import NotifyMe from 'shared/components/NotifyMe';
import { Variant, PrimaryCategories } from 'shared/store/product/types';
import Modal from 'shared/components/Modal';
import { getHeaderText } from './helpers';
import { CartData } from 'store/addToCart/types';
import { PageLocationType } from 'shared/store/categoryListing/types';
import { DEFAULT_LANGUAGE } from '@nykaa/intl-shared/constants';
import { TRACKING_EVENTS } from 'components/CartOperations/constants';
import { PageJourney } from 'store/dataLayer/action';
import { getCartViewLocation } from 'components/Header/RightNav/Notification/helpers';

interface AllShadesProps {
  variants: Variant[];
  product: Variant;
  showBestSeller: boolean;
  changeVariant: Function;
  parentId: string;
  brandName: string;
  onCloseHandler: Function;
  isSize?: boolean;
  handleAddToCartTracking: (cartData: CartData) => void;
  primaryCategories: PrimaryCategories;
  pageLocation: PageLocationType;
  clickedFrom?: string;
  newCtaText?: string;
  isGoToBag?: boolean;
  setIsGoToBag: (value: boolean) => void;
  setNewCtaText: (value: string) => void;
  journeyData: PageJourney;
  notchHeight?: number;
  handlePostAddToCart?: () => void;
  isConvSearch?: boolean;
  gptConversationId?: string;
  appTrackingKeys?: { [key: string]: any };
  readUrlParamsForTracking?: boolean;
}

const HeaderWrapper = styled.div`
  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.1);
  height: 48px;
  display: flex;
`;

const Wrapper = styled.div<{ notchHeight?: number }>`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding-top: ${({ notchHeight }) => notchHeight || 0}px;
`;

const AllShades = ({
  product,
  parentId,
  brandName,
  showBestSeller,
  variants,
  changeVariant,
  onCloseHandler,
  isSize,
  handleAddToCartTracking,
  primaryCategories,
  pageLocation,
  clickedFrom,
  newCtaText,
  isGoToBag,
  setIsGoToBag,
  setNewCtaText,
  journeyData,
  notchHeight,
  handlePostAddToCart,
  isConvSearch,
  gptConversationId,
  appTrackingKeys,
  readUrlParamsForTracking,
}: AllShadesProps) => {
  const { onlyWishlistButton, inStock } = product;
  const [selectedProdLang, setProdLang] = useState(
    product?.contentLang?.name || DEFAULT_LANGUAGE
  );
  const device = useSelector(
    (state: State) => state.appReducer?.client?.device
  );
  const variantType = `${isSize ? 'size' : 'shade'}`;

  const handleChangeVariant = (id: string) => {
    let variant = variants.find((item) => item?.childId === id);
    isValidFunc(setIsGoToBag) && setIsGoToBag(false);
    changeVariant(
      { id, contentLang: variant?.contentLang || {} },
      { ...product, id: parentId, variantType }
    );
    if (variant?.contentLang?.name) {
      setProdLang(variant?.contentLang?.name);
    }
  };
  const ALL_SHADE = 'all_shade';
  const pageSource = getCartViewLocation();
  return (
    <Modal onHide={() => onCloseHandler()}>
      <Wrapper notchHeight={notchHeight}>
        {(!isDeviceNotWeb(device) || isConvSearch) && (
          <HeaderWrapper>
            <PartialHeader
              title={getHeaderText(isSize)}
              onBack={() => onCloseHandler()}
            />
            <Bag
              cartViewLocation="productDetailPage:ViewShade:Bag"
              pageSource={pageSource}
              buttonId="variants-bag-icon"
              isConvSearch={isConvSearch}
            />
          </HeaderWrapper>
        )}
        <AllVariants
          isSize={isSize}
          changeVariant={handleChangeVariant}
          product={product}
          variants={variants}
          showBestSeller={showBestSeller}
          primaryCategories={primaryCategories}
        >
          {inStock || onlyWishlistButton ? (
            <Actions
              parentId={parentId}
              brandName={brandName}
              product={product}
              enableAnimation={false}
              handleAddToCartTracking={handleAddToCartTracking}
              primaryCategories={primaryCategories}
              pageLocation={pageLocation}
              pageType={ALL_SHADE}
              lang={selectedProdLang}
              clickedFrom={clickedFrom}
              newButtonText={product?.newButtonText}
              newCtaText={newCtaText}
              isGoToBag={isGoToBag}
              setIsGoToBag={setIsGoToBag}
              setNewCtaText={setNewCtaText}
              journeyData={journeyData}
              handlePostAddToCart={handlePostAddToCart}
              isConvSearch={isConvSearch}
              gptConversationId={gptConversationId}
              appTrackingKeys={appTrackingKeys}
              readUrlParamsForTracking={readUrlParamsForTracking}
            />
          ) : (
            <NotifyMe
              productId={product.childId}
              offerPrice={product.offerPrice}
              brandName={brandName}
              productName={product.variantName}
              primaryCategories={primaryCategories}
              isLux={product.isLux}
              pageSource={product?.pageSource}
              trackingData={`${product?.trackingParams}:${TRACKING_EVENTS.NOTIFY_ME}`}
              product={product}
              variantType={variantType}
            />
          )}
        </AllVariants>
      </Wrapper>
    </Modal>
  );
};

export default AllShades;
